module.exports = __webpack_public_path__ + "static/media/tv.f8132c20.svg";